import React, { useEffect } from 'react';
import { QueryObserverRefetchErrorResult, QueryObserverSuccessResult } from 'react-query';
import { IFVContainer } from '../interfaces/FVContainer.interface';
import Styled from '../styles/public/FerramentaVideoPublic.styled';
import { bucketS3, caminhoAnexosFerramentaVideo, caminhoAnexosGeneralFiles } from 'constants/EnvironmentData';
import { loadImageHelper } from 'helpers/ImageHelpers';
import Loading from 'components/Loading';
import { TextDangerouslySetInnerHtml } from 'pages/recursos/recursos-conteudo/RecursosConteudoPage.styled';
import { YellowButton } from 'components/UI/Buttons';
import Colors from 'enums/Colors';
import { useHistory } from 'react-router-dom';
import MenuTypePackages from '../components/MenuTypePackages';
import { IFVPackage } from '../interfaces/FVPackage.interface';

interface FVProps {
    // ...other props (history, location, match, etc.)...
    listFerramenta: QueryObserverRefetchErrorResult<IFVContainer, unknown> | QueryObserverSuccessResult<IFVContainer, unknown>;
    handleRedirect?: () => void;
    setMenuActive?: (menu: string) => void;
}

const FVHome = ({ listFerramenta, handleRedirect, setMenuActive }: FVProps) => {
    const history = useHistory();
    const [fetchedData, setFetchedData] = React.useState<IFVContainer | null>(null);
    const [imgSolucao, setSolucao] = React.useState<string>('');
    const [imgLoading, setImgLoading] = React.useState<boolean>(false);
    const [hoveredIndexCard, setHoveredIndexCard] = React.useState<number | null>(null);

    const refDiv = React.useRef<HTMLDivElement>(null);

    const handleRefDivClick = () => {
        if (refDiv.current) {
            refDiv.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const getBucketGeneralFiles = () => {
        return bucketS3() + caminhoAnexosGeneralFiles();
    };
    const getBucketFerramentaVideo = () => {
        return bucketS3() + caminhoAnexosFerramentaVideo();
    };

    const handlePacoteClick = (pacote: IFVPackage) => {
        if (pacote.notUnit) {
            history.push(
                `/videos/${fetchedData?.url}/${pacote.url}/${
                    pacote.packageUnits && pacote.packageUnits.length > 0 ? pacote.packageUnits[0].url : ''
                }/conteudos`
            );
        } else {
            history.push(`/videos/${fetchedData?.url}/${pacote.url}`);
        }
    };

    useEffect(() => {
        if (fetchedData && fetchedData.codigoSolucao?.logo) {
            setImgLoading(true);
            loadImageHelper(getBucketGeneralFiles() + fetchedData.codigoSolucao.logo)
                .then(src => setSolucao(src))
                .catch(() => setSolucao(''))
                .finally(() => setImgLoading(false));
        } else {
            setSolucao('');
            setImgLoading(false);
        }
    }, [fetchedData]);

    useEffect(() => {
        if (listFerramenta.data) {
            setFetchedData(listFerramenta.data);
        }
    }, [listFerramenta.data]);

    return (
        <Styled.Global.Content style={{ paddingTop: '36px' }}>
            <MenuTypePackages handleUpdateMenu={setMenuActive} hidden={listFerramenta?.data?.notAccessibility ?? false} />
            <Styled.Home.Container>
                {imgLoading ? (
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 2,
                        }}
                    >
                        <Loading />
                    </div>
                ) : null}
                <Styled.InitialAccess.ImgSolucoes
                    src={imgSolucao}
                    alt="Imagem da Ferramenta de Vídeo"
                    style={{ opacity: imgLoading ? 0.3 : 1, transition: 'opacity 0.2s' }}
                />

                <Styled.Home.Title>{listFerramenta.data?.title}</Styled.Home.Title>
                <TextDangerouslySetInnerHtml
                    style={{ maxWidth: '600px', margin: 0, fontSize: '24px' }}
                    dangerouslySetInnerHTML={{ __html: fetchedData?.description || '' }}
                />
                <YellowButton
                    style={{
                        height: '80px',
                        maxWidth: '290px',
                        minHeight: '52px',
                        textTransform: 'uppercase',
                        fontSize: '20px',
                        borderRadius: '8px',
                        order: 0,
                    }}
                    onClick={handleRefDivClick}
                    aria-label="Scroll para escolher livro"
                >
                    Escolher conteúdo
                </YellowButton>

                <Styled.Home.Title style={{ marginTop: '24px' }}>
                    SELECIONE <span style={{ color: Colors.Yellow }}> UM CONTEÚDO</span>
                </Styled.Home.Title>

                {/* Pacotes */}

                <Styled.Home.GridPackages ref={refDiv}>
                    {fetchedData?.pacotes && fetchedData.pacotes.length > 0 ? (
                        fetchedData.pacotes
                            .sort((a, b) => a.ordem - b.ordem)
                            .map((pacote, index) => (
                                <section key={pacote.id} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    <Styled.Home.Card.Container
                                        onMouseEnter={() => setHoveredIndexCard(index)}
                                        onMouseLeave={() => setHoveredIndexCard(null)}
                                        onClick={() => handlePacoteClick(pacote)}
                                    >
                                        <Styled.Home.Card.Content
                                            width="322px"
                                            background={Colors.White}
                                            radius="25px 0px 0px 25px"
                                            className="hoverCardPackage content"
                                        >
                                            <h1>{pacote.ordem}</h1>
                                        </Styled.Home.Card.Content>
                                        <Styled.Home.Card.Content
                                            width="282px"
                                            img={getBucketFerramentaVideo() + pacote.capaFilepath}
                                            radius="0px 25px 25px 0px"
                                            className="contentImg"
                                        ></Styled.Home.Card.Content>
                                    </Styled.Home.Card.Container>
                                    <Styled.Home.Card.Information.Container>
                                        <Styled.Home.RowBettween>
                                            <Styled.Home.Card.Information.Title hovered={hoveredIndexCard === index}>
                                                {pacote.title}
                                            </Styled.Home.Card.Information.Title>
                                        </Styled.Home.RowBettween>
                                        <Styled.Home.Card.Information.Description
                                            style={{
                                                height: '80px',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                            }}
                                            dangerouslySetInnerHTML={{ __html: pacote.description }}
                                        />

                                        <YellowButton
                                            onMouseEnter={() => setHoveredIndexCard(index)}
                                            onMouseLeave={() => setHoveredIndexCard(null)}
                                            onFocusCapture={() => setHoveredIndexCard(index)}
                                            onClick={() => handlePacoteClick(pacote)}
                                            style={{
                                                width: '240px',
                                                height: '52px',
                                                minHeight: '52px',
                                                textTransform: 'uppercase',
                                                fontSize: '20px',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                order: 0,
                                            }}
                                            aria-label={`Acessar o livro ${pacote.title}`}
                                        >
                                            Acessar Livro
                                        </YellowButton>
                                    </Styled.Home.Card.Information.Container>
                                </section>
                            ))
                    ) : (
                        <div>Nenhum pacote encontrado.</div>
                    )}
                </Styled.Home.GridPackages>

                <YellowButton
                    style={{
                        height: '48px',
                        minHeight: '48px',
                        maxWidth: '200px',
                        textTransform: 'uppercase',
                        borderRadius: '8px',
                        alignSelf: 'center',
                        marginTop: '50px',
                        marginBottom: '20px',
                        fontSize: '20px',
                    }}
                    onClick={handleRedirect}
                    aria-label="Sair da ferramenta de videos"
                >
                    Sair
                </YellowButton>
            </Styled.Home.Container>
        </Styled.Global.Content>
    );
};

export default FVHome;
